export function Load ()
{
	return {
		emergency:
		{
			"Expand": 'Ampliar',
			"Reduce": 'Reducir',
			"Close": 'Cerrar',
			"Cancel": 'Cancelar',
			"Apply": 'Aplicar',
			"Accept": 'Aceptar',
			"Ok": 'Ok',
			"No": 'No',
			"Yes": 'Sí'
		},
		
		login:
		{
			"Enter your email and password to log in.": 'Introduce tu correo electrónico y contraseña para acceder.',
			"Login failed, you may have made a mistake in either your email or password.": 'No se ha podido confirmar tu acceso, es posible que te hayas equivocado al escribir alguno de los datos',
			"Recover password": 'Recuperar contraseña',
			"Log in": 'Acceder',
			"Log out": 'Cerrar sesión',
			"You are now logged out": 'Se ha cerrado tu sesión',
			"Are you a new user?": "¿Eres un nuevo usuario?",
			"Tap here to create an account": "Toca aquí para crear tu cuenta"
		},
		
		error_404:
		{
			"Not found": 'No encontrado',
			"The resource you have requested is not here": 'El recurso que has solicitado no se encuentra en esta ubicación'
		},
		
		warnings:
		{
			"You need to choose a valid user role to reapply the permissions": 'Necesitas escoger un rol de usuario válido para poder aplicar sus permisos'
		},
		
		errors:
		{
			"Impossible to create: there is no data pack function": 'Imposible crear: no existe función de empaquetado de datos',
			"Impossible to delete: there is no data pack function": 'Imposible eliminar: no existe función de empaquetado de datos',
			"Impossible to update: there is no data pack function": 'Imposible editar: no existe función de empaquetado de datos',
			"The list items couldn't be retrieved": 'No se pudieron obtener los elementos de la lista',
			"The data couldn't be retrieved": 'No se pudieron obtener los datos',
			"You don't have enough permissions to see this page": 'No tienes permisos suficiente para acceder a esta página',
			"Invalid pack data mode": 'Tipo de empaquetado de datos no válido',
			"The loaded data is invalid, try selecting the workplace again": 'Los datos cargados no son correctos, prueba a escoger de nuevo el motel',
			"The loaded data is invalid, try selecting the user role again": 'Los datos cargados no son correctos, prueba a escoger de nuevo el rol de usuario',
			"The loaded data is invalid, try selecting the user again": 'Los datos cargados no son correctos, prueba a escoger de nuevo el usuario',
			"Unable to reapply the user role permissions, updating the current entity may lead to unexpected permissions": 'No se pudieron aplicar los permisos del rol de usuario, actualizar los datos de la entidad actual puede resultar en permisos no esperados',
			"This field is required": 'Este campo es obligatorio',
			"This field cannot be repeated": 'Ya existe otra entidad con este valor, este campo no puede repetirse',
			"Invalid value": 'Este valor no es válido'
		},
		
		roles:
		{
			"Deny": 'Denegar',
			"From role": 'Mismo que el rol',
			"Allow": 'Permitir',
			"Can create": 'Puede crear',
			"Cannot create": 'No puede crear',
			"Can finalize": 'Puede finalizar',
			"Cannot finalize": 'No puede finalizar',
			"Can extend": 'Puede ampliar estancia',
			"Cannot extend": 'No puede ampliar estancia',
			"Can convert to invoice": 'Puede crear factura',
			"Cannot convert to invoice": 'No puede crear factura',
			"Can assign": 'Puede asignar',
			"Cannot assign": 'No puede asignar',
			"Can free": 'Puede liberar',
			"Cannot free": 'No puede liberar',
			"Can view": 'Puede ver',
			"Cannot view": 'No puede ver',
			"Can edit": 'Puede editar',
			"Cannot edit": 'No puede editar',
			"Can delete": 'Puede eliminar',
			"Cannot delete": 'No puede eliminar'
		},
		
		"App title": 'Grupo Lois',
		
		"Administrator": 'Administrador',
		
		"Email address": 'Dirección de correo electrónico',
		"Password": 'Contraseña',
		"Repeat password": 'Repite la contraseña',
		
		"Welcome": 'Bienvenid@',
		"Welcome!": 'Bienvenid@!',
		"Hello": 'Hola',
		
		"Occupation map": 'Mapa de ocupación',
		"Add expense": 'Ingresar gasto',
		"Add reservation": 'Añadir reserva',
		"Main view": 'Vista principal',
		"Administration": 'Administración',
		
		"Settings": 'Configuración',
		"Workplaces": 'Moteles',
		"Roles": 'Roles',
		"Users": 'Usuarios',
		"Reservations": 'Reservas',
		"Packages": 'Abonos',
		"Cleaning": 'Limpieza',
		"Maintenance": 'Mantenimiento',
		"Expenses": 'Gastos',
		
		"User permissions": 'Permisos de usuario',
		"Admin permissions": 'Permisos de administrador',
		
		"Basic data": 'Datos básicos',
		"Personal data": 'Datos personales',
		"Security data": 'Datos de seguridad',
		"Role and permissions": 'Rol y permisos',
		
		"User role": 'Rol de usuario',
		"Specific permissions": 'Permisos específicos',
		"Known roles": 'Permisos conocidos',
		
		"Name": 'Nombre',
		"Last name": 'Apellidos',
		
		"View my reservations": 'Mis reservas',
		"View my packages": 'Mis abonos',
		"Update my details": 'Mis datos personales',
		"Change my password": 'Actualizar contraseña',
		"Log out": 'Cerrar sesión',
		
		"Enabled": 'Habilitado',
		"Disabled": 'Deshabilitado',
		"Cancel": 'Cancelar',
		"Update": 'Actualizar',
		"Save and edit": 'Guardar y modificar',
		"Save": 'Guardar',
		"Confirm deletion": 'Confirma la eliminación',
		"New": 'Nuevo',
		"Refresh": 'Actualizar',
		"Delete": 'Eliminar',
		
		"Languages": 'Idiomas',
		
		"Created in": 'Creado en',
		"Last modified in": 'Última modificación en',
		
		"Write here to search": 'Escribe aquí para buscar',
		"Only update these fields if you want to change the user password, leave them blank otherwise": 'Actualiza estos campos sólo si quieres cambiar la contraseña del usuario, en caso contrario déjalos en blanco',
		
		"Workplaces list": 'Lista de moteles',
		"Choose a workplace to see its details and change them": 'Escoge un motel para ver sus detalles y modificarlo',
		"New workplace": 'Nuevo motel',
		"Edit workplace": 'Modificar motel',
		"Are you sure to delete this workplace? This operation can't be undone.": '¿Está seguro de borrar este motel? Esta operación no se puede deshacer.',
		
		"Roles list": 'Lista de roles',
		"Choose a role to see its details and change them": 'Escoge un rol de usuario para ver sus detalles y modificarlo',
		"New role": 'Nuevo rol de usuario',
		"Edit role": 'Modificar rol de usuario',
		"Are you sure to delete this role? This operation can't be undone.": '¿Está seguro de borrar este rol de usuario? Esta operación no se puede deshacer.',
		
		"Users list": 'Lista de usuarios',
		"Choose a user to see its details and change them": 'Escoge un usuario para ver sus detalles y modificarlo',
		"New user": 'Nuevo usuario',
		"Edit user": 'Modificar usuario',
		"Are you sure to delete this user? This operation can't be undone.": '¿Está seguro de borrar este usuario? Esta operación no se puede deshacer.',
		
		"Find and use any of our services": 'Encuentra y usa cualquiera de nuestros servicios',
		"Covered parking": "Parking cubierto",
		"Outdoor parking": "Parking exterior",
		"Contract": "Contrato",
		"Contracts": "Contratos",
		"My profile": "Mi perfil",
		"View my contracts": "Mis contratos",
		"View my vehicles": "Mis vehículos",
		
		"New reservation": "Nueva reserva",
		"You're looking for a reservation in": "Estás realizando una reserva en",
		"Airport Parking Mallorca Covered": "Airport Parking Mallorca Cubierto",
		"Pick the dates of your stay and check the additional details. You can also specify another driver or another vehicle and whether you need and invoice or not": "Escoge las fechas de tu estancia y comprueba el resto de los detalles. También puedes especificar otro conductor o vehículo, y si necesitas factura o no.",
		"Date and time": "Fecha y hora",
		"From": "Desde",
		"To": "Hasta",
		"Driver details": "Datos del conductor",
		"The driver will be another person": "El conductor va a ser otra persona",
		"ID number": "DNI / NIF",
		"Phone": "Teléfono",
		"Notes": "Observaciones",
		"Vehicle": "Vehículo",
		"Pick another vehicle": "Escoge otro vehículo",
		"Billing details": "Datos de facturación",
		"Do you need an invoice?": "¿Necesitas una factura?",
		"Yes": "Sí",
		"No": "No",
		"Company name": "Nombre de la empresa",
		"Company VAT number": "NIF / CIF o número de IVA",
		"Address": "Dirección",
		"Postal code": "Código postal",
		"City / location": "Localidad",
		"Country": "País",
		"Make my reservation": "Haz mi reserva",
		
		"Create your account": "Crea tu cuenta",
		"Becoming a registered user is easy! Simply fill this form with your personal details and your first vehicle.": "¡Registrarse como usuario es muy fácil! Simplemente rellena este formulario con tus datos personales y tu primer vehículo.",
		"Fields marked with a red line are required.": "Los campos marcados con una línea roja son obligatorios",
		"Personal details": "Datos personales",
		"Phone number": "Número de teléfono",
		"Vehicle details": "Datos del vehículo",
		"Brand": "Marca",
		"Model": "Modelo",
		"Color": "Color",
		"Plate": "Matrícula",
		"The billing details are optional, but they may come in handy if you need an invoice addressed to your company.": "Los datos de facturación son opcionales, pero pueden serte útiles si necesitas una factura para tu empresa.",
		"Finally, set up a password for your account.": "Por último, escribe una contraseña para tu cuenta.",
		"Repeat the password": "Repite la contraseña",
		"Create my account": "Crea mi cuenta",
		
		"My vehicles": "Mis vehículos",
		"View and modify your data": "Revisa y modifica tus datos",
		"Connected as": "Conectado como",
		"Profile details": "Datos de tu perfil",
		"Acquired services": "Servicios adquiridos",
		"My reservations": "Mis reservas",
		"My packages": "Mis abonos",
		"My contracts": "Mis contratos",
		"Payment methods": "Métodos de pago",
		"My cards": "Mis tarjetas",
		"Check and update your details": "Revisa y modifica tus datos",
		"Use this form to review and change any of your profile data": "Usa este formulario para revisar y cambiar tus datos personales",
		"ID number type": "Tipo de documento de identidad",
		"VAT num type": "Tipo de documento de IVA",
		"VAT number": "NIF / CIF / Número de IVA",
		"State": "Provincia / estado",
		"Billing preference": "Configuración de facturación",
		"You can choose whether you'd like to setup your billing details automatically when you acquire a service, or if you'd prefer to default to a simplified invoice.": "Puedes escoger si te gustaría que siempre usáramos tus datos de facturación para solicitar factura automáticamente, o si prefieres adquirir servicios con una factura simplificada.",
		"Default to a simplified invoice": "Por defecto quiero factura simplificada",
		"I'd like to get full invoices": "Me gustaría tener facturas completas",
		"Update my profile": "Actualiza mis datos",
		"View and manage your vehicles": "Revisa y modifica tus vehículos",
		"Change password": "Cambiar contraseña",
		"Update your account password": "Actualiza la contraseña de tu cuenta",
		"Use this form to update the password for your account. Make sure you don't store the password anywhere unsafe": "Usa este formulario para actualizar la contraseña de tu cuenta. Asegúrate de no almacenar tu nueva contraseña en sitios poco seguros.",
		"Security": "Seguridad",
		"New password": "Nueva contraseña",
		"Update my password": "Actualiza mi contraseña",
		"View and manage your reservations": "Revisa y administra tus reservas",
		"View and manage your packages": "Revisa y administra tus abonos",
		"View and manage your contracts": "Revisa y administra tus contratos",
		"View and manage your cards": "Revisa y administra tus tarjetas"
		
	};
}